<mat-card style="margin: auto; min-width:300px" class="p-36">
  <div style="width: 100%">
    <div style="color: grey; font-size: 2rem; text-align: center" class="pb-36 pt-16">
      {{'APP.SELECT_TENANT' | translate}}
    </div>
    <mat-form-field style="width: 100%;" appearance="outline">
      <mat-label>Tenants</mat-label>
      <mat-select [formControl]="tenantSelector" class="p-12">
        <mat-option *ngFor="let tenant of tenants" value="{{tenant.id}}">
          <!-- <button mat-button (click)="select(tenant)" (keyup.enter)="select(tenant)" style="width: 100%">{{tenant.description}}</button> -->
          <a mat-button style="width: 100%">{{tenant.description}}</a>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</mat-card>